import React, { useContext, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Paperclip, X } from "react-feather";
import { Col, Input, InputGroup, Row } from "reactstrap";

import ChatAppContext from "../../../../src/Chat/index";

const SEND_ACCEPT =
  ".jpg,.jpeg,.png,.gif,.webp,.pdf,.doc,.docx,image/jpeg,image/png,image/gif,image/webp,application/pdf";

const SendChat = () => {
  const [messageInput, setMessageInput] = useState("");
  const [attachmentFile, setAttachmentFile] = useState(null);
  const fileInputRef = useRef(null);

  const context = useContext(ChatAppContext);

  if (!context) {
    return <div>Loading...</div>;
  }

  const { sendChatMessage, selectedUser } = context;

  // Check if this is a support chat
  const isSupportChat = selectedUser?.chat_type === "support" || selectedUser?.support_chat === true;

  const handleMessageChange = (message) => {
    setMessageInput(message);
  };

  const handleMessagePress = (e) => {
    const isSend = e === "send" || e.key === "Enter";
    if (!isSend) return;
    const text = messageInput.trim();
    if (!text && !attachmentFile) return;
    sendChatMessage(text || " ", attachmentFile ? { attachment: attachmentFile } : {});
    setMessageInput("");
    setAttachmentFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const onAttachmentChosen = (ev) => {
    const f = ev.target.files?.[0];
    if (!f) return;
    const allowedExts = ["jpg", "jpeg", "png", "gif", "webp", "pdf", "doc", "docx", "txt"];
    const ext = f.name.split(".").pop().toLowerCase();
    if (!allowedExts.includes(ext)) {
      toast.error("Invalid file format! Allowed formats: Images, PDF, DOC, DOCX, TXT.");
      ev.target.value = "";
      return;
    }
    if (f.size > 5 * 1024 * 1024) {
      toast.error("File must be 5MB or smaller");
      ev.target.value = "";
      return;
    }
    setAttachmentFile(f);
  };

  return (
    <div className="chat-message clearfix">
      <Row>
        {/* <div>
          {showEmojiPicker ? (
            <Picker set="apple" emojiSize={30} onSelect={addEmoji} />
          ) : null}
        </div> */}
        <Col xl="12" className="d-flex flex-column">
          {/* <div className="smiley-box bg-primary">
            <div className="picker" onClick={() => toggleEmojiPicker()}>
              <img src="path_to_smiley_image" alt="" />
            </div>
          </div> */}
          {attachmentFile ? (
            <div className="d-flex align-items-center gap-2 small text-muted mb-1 px-1">
              <Paperclip size={14} aria-hidden />
              <span className="text-truncate" title={attachmentFile.name}>
                {attachmentFile.name}
              </span>
              <button
                type="button"
                className="btn btn-link btn-sm text-danger p-0 ms-auto"
                onClick={() => {
                  setAttachmentFile(null);
                  if (fileInputRef.current) fileInputRef.current.value = "";
                }}
                aria-label="Remove attachment"
              >
                <X size={16} />
              </button>
            </div>
          ) : null}
          <InputGroup className="text-box">
            {isSupportChat ? (
              <>
                <input
                  ref={fileInputRef}
                  type="file"
                  className="d-none"
                  accept={SEND_ACCEPT}
                  onChange={onAttachmentChosen}
                />
                <button
                  type="button"
                  className="btn chat-attach-btn"
                  onClick={() => fileInputRef.current?.click()}
                  title="Attach file (support chat)"
                  aria-label="Attach file"
                >
                  <Paperclip size={18} aria-hidden />
                </button>
              </>
            ) : null}
            <Input
              type="text"
              className="form-control input-txt-bx"
              placeholder="Type a message......"
              value={messageInput}
              onKeyPress={(e) => handleMessagePress(e)}
              onChange={(e) => handleMessageChange(e.target.value)}
            />
            <button
              className="btn btn-primary"
              onClick={() => handleMessagePress("send")}
            >
              Send
            </button>
          </InputGroup>
        </Col>
      </Row>
    </div>
  );
};

export default SendChat;
